// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"75a92f23","430":"cc7797fe","940":"a214c85e"}[chunkId] + ".chunk.js";
};